import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { AR } from '../../../../types/enums';
import { useGetPOInvoice } from '../api/get-po-invoice';
import { POInvoiceContext } from '../context/POInvoiceContext';
import { PurchaseOrderContext } from '../context/PurchaseOrderContext';
import { POInvoiceContextType } from '../types/POInvoiceContextType';
import { POInvoiceProduct } from '../types/POInvoiceProduct';

export default function POInvoicePage(props: React.PropsWithChildren<unknown>) {

	const { order } = useContext(PurchaseOrderContext);

	const params = useParams();
	const poInvoiceID = params.poInvoiceID ? parseInt(params.poInvoiceID) :
		(order.details.invoices?.length > 0 &&
			(order.details.resolvedARs.includes(AR.PODistributorToInvoice) ||
				order.details.resolvedARs.includes(AR.POServiceProviderToInvoice))) ?
			order.details.invoices[0].poInvoiceID : undefined;

	const { data: invoiceData } = useGetPOInvoice(poInvoiceID);

	const [invoice, setInvoice] = useState<POInvoiceContextType>(
		{
			details: {
				products: order.details.products.filter(x => !x.invoiced).map((x, index) => {
					return {
						selected: false,
						poInvProductID: -index - 1,
						poProductID: x.poProductID,
						sku: x.sku,
						itemDescription: x.itemDescription,
						uom: x.uom,
						thickness: x.thickness,
						dimensions: x.dimensions,
						squareFootage: x.squareFootage,
						quantity: order.details.deliveryFlow ? x.qtyDelivered : x.qtyShipped,
						unitPrice: x.unitCost,
						freightCost: x.freightCost,
						totalCost: x.totalCost
					} as POInvoiceProduct
				}),
				subTotal: 0,
				invoiceTotal: 0,
				tax: 0,
				discount: 0,
				cutCharge: 0,
				freightAmount: 0,
			}
		}
	);

	useEffect(() => {
		if (invoiceData) {
			setInvoice({ details: invoiceData });
		}
	}, [invoiceData]);

	return (
		<React.Fragment>
			{
				invoice.details &&
				<POInvoiceContext.Provider value={{
					invoice: invoice,
					modify: (details) => setInvoice({ details: details })
				}}>
					{props.children}
				</POInvoiceContext.Provider>
			}
		</React.Fragment>)
}
